var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","open-delay":500},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-avatar',_vm._g(_vm._b({staticClass:"elevation-2",attrs:{"size":"36","color":_vm.color}},'v-avatar',attrs,false),on),[(!_vm.user)?_c('v-icon',[_vm._v(" mdi-account-circle ")]):_c('span',[_vm._v(_vm._s(_vm.avatar))])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.user ? _vm.user : 'You'))])])}
var staticRenderFns = []

export { render, staticRenderFns }